"use client";

import React, { useState } from "react";
import "./lifestyle.css";
import Link from "next/link";

const LifestylePop = ({
  backgroundImage,
  title,
  subtext,
  subtitle,
  title2,
  subtext2,
  popUpContent,
  popUpContent2,
  logo1,
  logo2,
  logo3,
  button1,
  button2,
  button3,
  contentAlign,
  popUpImage,
  popUpImage2,
  butcol,
  but2transform,
  isUseInAppVisible,
  showOBPPill,
  getOBBookingLink,
}) => {
  const [activePopup, setActivePopup] = useState(null);

  const openPopUp = (popupKey) => {
    setActivePopup(popupKey);
  };

  const closePopUp = () => {
    setActivePopup(null);
  };

  const activeContent =
    activePopup === 2 && popUpContent2 ? popUpContent2 : popUpContent;
  const activeImage =
    activePopup === 2 && popUpImage2 ? popUpImage2 : popUpImage;

  const alignment = contentAlign === "left" ? "flex-start" : "flex-end";

  const generateIdFromTitle = (title) => {
    return title.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "");
  };

  // Custom function to render Content
  const renderContent = (content) => {
    if (Array.isArray(content)) {
      return content.map((item, index) => <div key={index}>{item}</div>);
    } else if (typeof content === "string") {
      return <div dangerouslySetInnerHTML={{ __html: content }} />;
    } else {
      return <div>{content}</div>;
    }
  };

  return (
    <section className="section-bg" id={generateIdFromTitle(title)}>
      <div
        className={`lifestyle-cont ${showOBPPill ? "OBP-cont" : ""}`}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          alignItems: alignment,
        }}
      >
        {showOBPPill && <div className="OBP-pill">Off beat plus</div>}{" "}
        {/* Conditionally render OBP-pill */}
        <div className="overlay"></div>
        <div className="content-cont">
          <h1 id='Titlecolour'>{title}</h1>
          <div>{renderContent(subtext)}</div>
          <h3>{subtitle}</h3>
          <h1>{title2}</h1>
          <div>{renderContent(subtext2)}</div>
          <div className="logos-cont">
            <div
              className={
                logo1.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo1.src} alt={logo1.alt} />
            </div>
            <div
              className={
                logo2.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo2.src} alt={logo2.alt} />
            </div>
            <div
              className={
                logo3.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo3.src} alt={logo3.alt} />
            </div>
          </div>
          {button1.popup ? (
            <button
              style={{ backgroundColor: butcol }}
              className={button1.visibility ? "btn visible" : "btn hidden"}
              onClick={() => openPopUp(1)}
            >
              {button1.text}
            </button>
          ) : (
            <Link
              href={button1?.ssoLink ? "/" : button1.link}
              onClick={(e) => {
                if (button1?.ssoLink) {
                  e.preventDefault();
                  getOBBookingLink(button1.ssoLink);
                }
              }}
            >
              <button
                style={{ backgroundColor: butcol }}
                className={button1.visibility ? "btn visible" : "btn hidden"}
              >
                {button1.text}
              </button>
            </Link>
          )}
          {button2.popup ? (
            <button
              style={{ textTransform: but2transform }}
              className={button2.visibility ? "btn visible" : "btn hidden"}
              onClick={() => openPopUp(1)}
            >
              {button2.text}
            </button>
          ) : (
            <Link href={button2.link} target={button2?.newTab ? "_blank" : ""}>
              <button
                className={button2.visibility ? "btn visible" : "btn hidden"}
              >
                {button2.text}
              </button>
            </Link>
          )}
          {button3.popup ? (
            <button
              style={{ textTransform: but2transform }}
              className={button3.visibility ? "btn visible" : "btn hidden"}
              onClick={() => openPopUp(2)}
            >
              {button3.text}
            </button>
          ) : (
            <Link href={button3.link}>
              <button
                className={
                  button3.visibility
                    ? "btn btn-color visible"
                    : "btn btn-color hidden"
                }
              >
                {button3.text}
              </button>
            </Link>
          )}
          {isUseInAppVisible && (
            <p className="uia">
              use in <span>App</span>
            </p>
          )}
        </div>
      </div>
      {activePopup && (
        <div className="pop-up">
          <button className="close-btn" onClick={closePopUp}>
            X
          </button>
          <img src={activeImage} width="200px" alt="Pop-up" />
          {renderContent(activeContent)}
        </div>
      )}
    </section>
  );
};

export default LifestylePop;
